import { getHistoryEventDate } from 'shared/lib/format';

interface HistoryEventDateProps {
  date: string;
}

export function HistoryEventDate({ date }: HistoryEventDateProps) {
  const formattedDate = getHistoryEventDate(date);
  const [firstRow, secondRow] = formattedDate.split(' ');

  return (
    <>
      <div className="font-medium leading-[18px] text-slate-900">{firstRow}</div>
      <div className="text-[10px] font-medium leading-4 text-slate-600">{secondRow}</div>
    </>
  );
}
